import Vue from 'vue'
import Vuex from 'vuex'
import { createServiceObject } from './storeHelper'

Vue.use(Vuex)

export const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  // modify the state object dynamically will trigger all getters, so all know property are declared and initialized (ex: selectedBranch)
  state: {
    // debug
    funcDebug: process.env.NODE_ENV !== 'production',
    // languages
    messages: {},
    defaultCountryPrefix: null,
    selectedLanguage: null,
    // services data
    isServicesStepValid: false,
    selectedServices: [],
    servicesTranslations: {},
    preSelectedServices: [],
    // branch data
    isBranchStepValid: false,
    selectedBranch: {
      id: '',
      name: '',
      addressCity: '',
      addressLine1: '',
      addressLine2: '',
      addressZip: ''
    },
    branchTranslations: {},
    preSelectedBranch: '',
    // serviceGroups
    preSelectedServiceGroups: [],
    // date time selection
    selectedTimeSlot: '',
    selectedDate: '',
    reservedAppointmentId: null,
    condTotalCost: 0, // conditional total cost
    // contact
    contactDetails: {
      formattedPhone: '',
      phone: '',
      email: '',
      countryCode: '',
      lastName: '',
      firstName: '',
      DOB: '',
      confirmEmail: '',
      confirmPhone: '',
      custRef: '',
      notes: ''
    },
    customFields: [],
    // misc
    configuration: null,
    serviceTemplates: {},
    securityToken: '',
    appMode: 'New'
  },
  // Getter are used if data needs to be filtered or transformed, otherwise access directly the state
  // NAMING getXXXX, getXXXXByYY, IsXXXX
  getters: {
    selectedServicesTotalCost: state => {
      let sum = 0
      state.selectedServices.forEach(service => {
        sum += service.totalCost
      })
      return sum
    },
    customSlotLength: state => {
      let sum = 0
      state.selectedServices.forEach(service => {
        sum += service.customLength
      })
      return sum
    },
    isDateTimeSelectionStepValid: state => {
      return ((state.selectedTimeSlot.length > 0) && (state.selectedDate.length > 0) && (state.reservedAppointmentId))
    },
    isBranchPreselected: state => {
      return state.preSelectedBranch.length > 0
    },
    isServicesPreselected: state => {
      return state.preSelectedServices.length > 0
    },
    isBranchAndServicesValid: state => {
      return state.isBranchStepValid && state.isServicesStepValid
    },
    isServiceGroupsPreselected: state => {
      return state.preSelectedServiceGroups.length > 0
    },
    getSecurityToken: state => {
      return state.securityToken
    },
    getAppMode: state => {
      return state.appMode
    }

  },
  // mutation concern is only changing the state, they are the only ones that can do it
  // mutation are sync
  // don't use mutation from the application
  // NAMING: setXXX
  // action is supposed to change
  mutations: {
    // languages
    setMessages: (state, payload) => {
      state.messages = payload
    },
    setMessagesAgreementHtml1: (state, payload) => {
      state.messages = { ...state.messages, agreementHtml1: payload }
    },
    setMessagesAgreementHtml2: (state, payload) => {
      state.messages = { ...state.messages, agreementHtml2: payload }
    },
    setSelectedLanguage: (state, payload) => {
      state.selectedLanguage = payload
    },
    setDefaultCountryPrefix: (state, payload) => {
      state.defaultCountryPrefix = payload
    },
    // services mutations
    setServicesStepValid: (state, payload) => {
      state.isServicesStepValid = payload
    },
    updateSelectedService: (state, payload) => {
      state.selectedServices = [
        ...state.selectedServices.filter(element => element.id !== payload.id),
        payload]
    },
    setSelectedServices: (state, payload) => {
      state.selectedServices = payload
    },
    setServicesTranslations: (state, payload) => {
      state.servicesTranslations = payload
    },
    setPreSelectedServices: (state, payload) => {
      state.preSelectedServices = payload
    },
    setServiceTemplates: (state, payload) => {
      state.serviceTemplates = payload
    },
    // branch mutations
    setBranchStepValid: (state, payload) => {
      state.isBranchStepValid = payload
    },
    setSelectedBranch: (state, payload) => {
      state.selectedBranch = payload
    },
    setBranchTranslations: (state, payload) => {
      state.branchTranslations = payload
    },
    setPreSelectedBranch: (state, payload) => {
      state.preSelectedBranch = payload
    },
    // servicegroups
    setPreSelectedServiceGroups: (state, payload) => {
      state.preSelectedServiceGroups = payload
    },
    // date time
    setSelectedDate: (state, payload) => {
      state.selectedDate = payload
    },
    setSelectedTimeSlot: (state, payload) => {
      state.selectedTimeSlot = payload
    },
    setReservedAppointmentId: (state, payload) => {
      state.reservedAppointmentId = payload
    },
    setCondTotalCost: (state, payload) => {
      state.condTotalCost = payload
    },
    // contact
    setContactDetails: (state, payload) => {
      state.contactDetails = payload
    },
    setCustomFields: (state, customFields) => {
      state.customFields = customFields
    },
    // misc
    setConfiguration: (state, payload) => {
      state.configuration = payload
    },
    setSecurityToken: (state, payload) => {
      state.securityToken = payload
    },
    setAppMode: (state, payload) => {
      state.appMode = payload
    }
  },
  // action are async
  // action can change multiple states
  actions: {
    // languages
    setMessages: ({ commit }, payload) => {
      commit('setMessages', payload)
    },
    setDefaultCountryPrefix: ({ commit }, payload) => {
      commit('setDefaultCountryPrefix', payload)
    },
    setSelectedLanguage: ({ commit }, payload) => {
      commit('setSelectedLanguage', payload)
    },
    // services actions
    addSelectedService: ({ commit }, payload) => {
      if (payload.hasOwnProperty('publicId')) {
        var serviceToStore = createServiceObject(payload)
        commit('updateSelectedService', serviceToStore)
      }
    },
    setSelectedServices: (context, payLoad) => {
      var servicesList = []
      for (let service of payLoad) {
        let serviceToStore = createServiceObject(service)
        servicesList.push(serviceToStore)
      }
      context.commit('setSelectedServices', servicesList)
    },
    resetSelectedServices: ({ commit }) => {
      commit('setSelectedServices', [])
    },
    checkServicesValidity: (context) => {
      var isValid = false
      if (context.state.selectedServices.length > 0) {
        isValid = true
        if (context.state.configuration.multiplePeopleEnabled) { // check if there is at least one person
          for (var i = 0; i < context.state.selectedServices.length; i++) {
            if ((context.state.selectedServices[i].adult < 1) && (context.state.selectedServices[i].child < 1)) {
              isValid = false
              break
            }
          }
        }
      }
      context.commit('setServicesStepValid', isValid)
    },
    // branch actions
    setSelectedBranch: ({ commit }, payload) => {
      var branchToStore = {}
      if (payload.hasOwnProperty('id')) {
        branchToStore.id = payload.id
        if (payload.hasOwnProperty('name')) {
          branchToStore.name = payload.name
        } else {
          branchToStore.name = ''
        }
        if (payload.hasOwnProperty('addressCity')) {
          branchToStore.addressCity = payload.addressCity
        } else {
          branchToStore.addressCity = ''
        }
        if (payload.hasOwnProperty('addressLine1')) {
          branchToStore.addressLine1 = payload.addressLine1
        } else {
          branchToStore.addressLine1 = ''
        }
        if (payload.hasOwnProperty('addressLine2')) {
          branchToStore.addressLine2 = payload.addressLine2
        } else {
          branchToStore.addressLine2 = ''
        }
        if (payload.hasOwnProperty('addressZip')) {
          branchToStore.addressZip = payload.addressZip
        } else {
          branchToStore.addressZip = ''
        }
        commit('setSelectedBranch', branchToStore)
      }
    },
    resetSelectedBranch: ({ commit }) => {
      commit('setSelectedBranch', {
        id: '',
        name: '',
        addressCity: ''
      })
    },
    checkBranchValidity: (context) => {
      let isValid = false
      if (context.state.selectedBranch.id.length > 0) {
        isValid = true
      }
      context.commit('setBranchStepValid', isValid)
    },
    // date time
    resetSelectedDate: ({ commit }) => {
      commit('setSelectedDate', '')
    },
    resetSelectedTimeSlot: ({ commit }) => {
      commit('setSelectedTimeSlot', '')
    },
    resetSelectedDateAndTimeSlot: ({ commit }) => {
      commit('setSelectedDate', '')
      commit('setSelectedTimeSlot', '')
    },
    setSelectedDate: ({ commit }, payload) => {
      commit('setSelectedDate', payload)
    },
    setSelectedTimeSlot: ({ commit }, payload) => {
      commit('setSelectedTimeSlot', payload)
    },
    setReservedAppointmentId: ({ commit }, payload) => {
      commit('setReservedAppointmentId', payload)
    },
    resetReservedAppointmentId: ({ commit }, payload) => {
      commit('setReservedAppointmentId', null)
    },
    setCondTotalCost: ({ commit }, payload) => {
      commit('setCondTotalCost', payload)
    },
    // contact
    resetContactDetails: ({ commit }, payload) => {
      var newcontactDetails = {
        formattedPhone: '',
        phone: '',
        email: '',
        countryCode: '',
        lastName: '',
        firstName: '',
        DOB: '',
        confirmEmail: '',
        confirmPhone: '',
        custRef: '',
        notes: ''
      }
      commit('setContactDetails', newcontactDetails)
    },
    setContactDetails: ({ commit }, payload) => {
      var newcontactDetails = {
        formattedPhone: '',
        phone: '',
        email: '',
        countryCode: '',
        lastName: '',
        firstName: '',
        DOB: '',
        confirmEmail: '',
        confirmPhone: '',
        custRef: '',
        notes: ''
      }
      if (payload.hasOwnProperty('formattedPhone')) {
        newcontactDetails.formattedPhone = payload.formattedPhone
      }
      if (payload.hasOwnProperty('Phone')) {
        newcontactDetails.phone = payload.Phone
      }
      if (payload.hasOwnProperty('Email')) {
        newcontactDetails.email = payload.Email
      }
      if (payload.hasOwnProperty('countryCode')) {
        newcontactDetails.countryCode = payload.countryCode
      }
      if (payload.hasOwnProperty('LastName')) {
        newcontactDetails.lastName = payload.LastName
      }
      if (payload.hasOwnProperty('FirstName')) {
        newcontactDetails.firstName = payload.FirstName
      }
      if (payload.hasOwnProperty('DOB')) {
        newcontactDetails.DOB = payload.DOB
      }
      if (payload.hasOwnProperty('ConfirmEmail')) {
        newcontactDetails.confirmEmail = payload.ConfirmEmail
      }
      if (payload.hasOwnProperty('ConfirmPhone')) {
        newcontactDetails.confirmPhone = payload.ConfirmPhone
      }
      if (payload.hasOwnProperty('CustRef')) {
        newcontactDetails.custRef = payload.CustRef
      }
      if (payload.hasOwnProperty('Notes')) {
        newcontactDetails.notes = payload.Notes
      }
      commit('setContactDetails', newcontactDetails)
    },
    setCustomFields: (context, selectionPerProperties) => {
      var newCustomFieldsList = []
      var customProperties = context.state.configuration.customProperties
      if (customProperties !== '') {
        if (customProperties.enabled === true) {
          var customPropertiesList = customProperties.customPropertiesList
          for (let i = 0; i < customPropertiesList.length; i++) {
            let isActive = false
            if (customPropertiesList[i].onlyForServices && customPropertiesList[i].onlyForServices.length > 0) {
              isActive = customPropertiesList[i].active === true && context.state.selectedServices.some(r => customPropertiesList[i].onlyForServices.indexOf(r.publicId) >= 0)
            } else {
              isActive = customPropertiesList[i].active === true
            }
            if (isActive) {
              var newCustomField = {}
              newCustomField.label = customPropertiesList[i].labels
              var paramName = customPropertiesList[i].parameterName
              var selectionProp = selectionPerProperties[paramName]
              if (selectionProp) {
                if (customPropertiesList[i].parameterType === 'MultipleChoice') {
                  newCustomField.selection = customPropertiesList[i].values.find((element) => element.value === selectionProp).labels
                } else if (customPropertiesList[i].parameterType === 'MultipleSelection') {
                  newCustomField.selection = selectionProp.reduce((previousArray, currentValue) => {
                    let myString = customPropertiesList[i].values.find((element) => element.value === currentValue).labels
                    previousArray.push(myString)
                    return previousArray
                  }, [])
                } else {
                  newCustomField.selection = selectionProp
                }
              } else {
                newCustomField.selection = ''
              }
              newCustomFieldsList.push(newCustomField)
            }
          }
        }
      }
      context.commit('setCustomFields', newCustomFieldsList)
    },
    // misc
    setConfiguration: ({ commit }, payload) => {
      commit('setConfiguration', payload)
    },
    setSecurityToken: ({ commit }, payload) => {
      commit('setSecurityToken', payload)
    },
    resetBookingStore: ({ commit }) => {
      commit('setReservedAppointmentId', null)
      commit('setServicesStepValid', false)
      commit('setBranchStepValid', false)
      commit('setPreSelectedServices', [])
      commit('setPreSelectedBranch', '')
      commit('setPreSelectedServiceGroups', [])
      commit('setSelectedBranch', {
        id: '',
        name: '',
        addressCity: ''
      })
      commit('setSelectedServices', [])
      commit('setSelectedDate', '')
      commit('setSelectedTimeSlot', '')
      var newcontactDetails = {
        formattedPhone: '',
        phone: '',
        email: '',
        countryCode: '',
        lastName: '',
        firstName: '',
        DOB: '',
        confirmEmail: '',
        confirmPhone: '',
        custRef: '',
        notes: ''
      }
      commit('setContactDetails', newcontactDetails)
      commit('setCondTotalCost', 0)
      commit('setCustomFields', [])
    },
    setAppMode: ({ commit }, payload) => {
      commit('setAppMode', payload)
    }
  }
})
